// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNUSED FUNCTION
// MODFIED DATA : 02-09-2025

/* eslint-disable import/no-anonymous-default-export */
import AutoLoanProposalActionTypes from './auto-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// SEARCH AUTO LOAN RESPONSE
	searchMemberListResponse: null,
	searchMemberListArr: [],
	// ADD NEW MEMBER LIST RESPONSE
	createMemberListResponse: [],
	createMemberListArr: [],
	// ADD NEW MEMBER ADDRESS LIST RESPONSE
	addAutoLoanMemberAddressResponse: null,
	// ADD NEW MEMBER BANK LIST RESPONSE
	addAutoLoanMemberBankResponse: null,
	// ADD NEW MEMBER IMAGE LIST RESPONSE
	addAutoLoanMemberImageResponse: null,
	// ADD NEW MEMBER COAPPLICANT LIST RESPONSE
	addAutoLoanMemberCoapplicantResponse: null,
	// ADD NEW MEMBER COAPPLICANT DOCUMENT LIST RESPONSE
	addAutoLoanMemberCoapplicantDocumentResponse: null,
	// ADD NEW MEMBER VEHICLE LIST RESPONSE
	addAutoLoanMemberVehicleResponse: null,
	// ADD NEW MEMBER VEHICLE DOCUMENT LIST RESPONSE
	addAutoLoanMemberVehicleDocumentResponse: null,
	// ADD NEW MEMBER BUSINESS LIST RESPONSE
	addAutoLoanMemberBusinessResponse: null,
	// ADD NEW MEMBER BUSINESS IMAGE LIST RESPONSE
	addAutoLoanMemberBusinessImageResponse: null,
	// ADD AUTO LOAN PROPOSAL RESPONSE
	addAutoLoanResponse: null,
	// FETCH AUTO LOAN PROPOSAL RESPONSE
	fetchAutoLoanResponse: null,
	// FETCH AUTO LOAN PROPOSAL RESPONSE
	fetchAutoLoanArr: [],
	// APPROVE AUTO LOAN PROPOSAL RESPONSE
	approveAutoLoanIndexResponse: null,
	// REVERT AUTO LOAN PROPOSAL RESPONSE
	revertAutoLoanIndexResponse: null,
	// DELETE AUTO LOAN PROPOSAL RESPONSE
	deleteAutoLoanIndexResponse: null,
	// ADD AUTO LOAN PROPOSAL RESPONSE
	addAutoLoanArr: [],
	// FETCH AUTO LOAN PROPOSAL DETAIL RESPONSE
	getParticularAutoLoanArr: [],
	getParticularAutoLoanResponse: null,
	// UPDATE VEHCILE IMAGE RESPONSE
	updateImageResp: null,
	// FETCH ALL DEALER LIST RESPONSE
	fetchAllDealerListResp: null,
	fetchAllDealerListArr: [],
	// FETCH PERMANT PINCODE RESPONSE
	getPermantPincodeResp: null,
	getPermantPincodeArr: [],
	// CHECK AUTO LOAN MANDATORY DETAILS RESPONSE
	checkAutoLoanMandatoryDetailsResponse: null,
	checkAutoLoanMandatoryDetailsArr: [],
	// UPDATE AUTO LOAN INDEX RESPONSE
	UpdateAutoLoanIndexReponse: null,
	UpdateAutoLoanIndexReponeArr: [],
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/***************** SEARCH AUTO LOAN START ***********************/
		case AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_SUCCESS:
			return {
				...state,
				searchMemberListResponse: action.payload,
				searchMemberListArr: docodeHexResponse(action.payload, 'SearchAutoLoanKey'),
			};

		case AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_FAILURE:
			return { ...state, searchMemberListResponse: action.payload, searchMemberListArr: [] };

		case AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, searchMemberListResponse: null };
		/***************** SEARCH AUTO LOAN END ***********************/

		/***************** ADD NEW MEMBER LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_SUCCESS:
			return {
				...state,
				createMemberListResponse: action.payload,
				createMemberListArr: docodeHexResponse(action.payload, 'AddAutoMemberBasicKey'),
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_FAILURE:
			return { ...state, createMemberListResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_REPONSE_CHANGED:
			return { ...state, createMemberListResponse: null };

		/***************** ADD NEW MEMBER LIST END ***********************/

		/***************** ADD NEW MEMBER ADDRESS LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_SUCCESS:
			return {
				...state,
				addAutoLoanMemberAddressResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_FAILURE:
			return { ...state, addAutoLoanMemberAddressResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_REPONSE_CHANGED:
			return { ...state, addAutoLoanMemberAddressResponse: null };

		/***************** ADD NEW MEMBER ADDRESS LIST END ***********************/

		/***************** ADD NEW MEMBER BANK LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_SUCCESS:
			return {
				...state,
				addAutoLoanMemberBankResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_FAILURE:
			return { ...state, addAutoLoanMemberBankResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_REPONSE_CHANGED:
			return { ...state, addAutoLoanMemberBankResponse: null };

		/***************** ADD NEW MEMBER BANK LIST END ***********************/

		/***************** ADD NEW MEMBER IMAGE LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_SUCCESS:
			return {
				...state,
				addAutoLoanMemberImageResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_FAILURE:
			return { ...state, addAutoLoanMemberImageResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_REPONSE_CHANGED:
			return { ...state, addAutoLoanMemberImageResponse: null };

		/***************** ADD NEW MEMBER IMAGE LIST END ***********************/

		/***************** ADD NEW MEMBER COAPPLICANT LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_SUCCESS:
			return {
				...state,
				addAutoLoanMemberCoapplicantResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_FAILURE:
			return { ...state, addAutoLoanMemberCoapplicantResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_CHANGED:
			return { ...state, addAutoLoanMemberCoapplicantResponse: null };

		/***************** ADD NEW MEMBER COAPPLICANT LIST END ***********************/

		/***************** ADD NEW MEMBER COAPPLICANT DOCUMENT LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_SUCCESS:
			return {
				...state,
				addAutoLoanMemberCoapplicantDocumentResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_FAILURE:
			return { ...state, addAutoLoanMemberCoapplicantDocumentResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_REPONSE_CHANGED:
			return { ...state, addAutoLoanMemberCoapplicantDocumentResponse: null };

		/***************** ADD NEW MEMBER COAPPLICANT DOCUMENT LIST END ***********************/

		/***************** ADD NEW MEMBER VEHICLE LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_SUCCESS:
			return {
				...state,
				addAutoLoanMemberVehicleResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_FAILURE:
			return {
				...state,
				addAutoLoanMemberVehicleResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_REPONSE_CHANGED:
			return {
				...state,
				addAutoLoanMemberVehicleResponse: null,
			};
		/***************** ADD NEW MEMBER VEHICLE LIST END ***********************/

		/***************** ADD NEW MEMBER VEHICLE DOCUMENT LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_SUCCESS:
			return {
				...state,
				addAutoLoanMemberVehicleDocumentResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_FAILURE:
			return {
				...state,
				addAutoLoanMemberVehicleDocumentResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_REPONSE_CHANGED:
			return {
				...state,
				addAutoLoanMemberVehicleDocumentResponse: null,
			};

		/***************** ADD NEW MEMBER VEHICLE DOCUMENT LIST END ***********************/

		/***************** ADD NEW MEMBER BUSINESS LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_SUCCESS:
			return {
				...state,
				addAutoLoanMemberBusinessResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_FAILURE:
			return {
				...state,
				addAutoLoanMemberBusinessResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_REPONSE_CHANGED:
			return {
				...state,
				addAutoLoanMemberBusinessResponse: null,
			};

		/***************** ADD NEW MEMBER BUSINESS LIST END ***********************/

		/***************** ADD NEW MEMBER BUSINESS IMAGE LIST START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_SUCCESS:
			return {
				...state,
				addAutoLoanMemberBusinessImageResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_FAILURE:
			return {
				...state,
				addAutoLoanMemberBusinessImageResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_REPONSE_CHANGED:
			return {
				...state,
				addAutoLoanMemberBusinessImageResponse: null,
			};

		/***************** ADD NEW MEMBER BUSINESS IMAGE LIST END ***********************/

		/***************** ADD NEW MEMBER AUTO LOAN INDEX START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS:
			return {
				...state,
				addAutoLoanMemberAutoLoanIndexResponse: action.payload,
			};
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE:
			return {
				...state,
				addAutoLoanMemberAutoLoanIndexResponse: action.payload,
			};
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED:
			return {
				...state,
				addAutoLoanMemberAutoLoanIndexResponse: action.payload,
			};
		/***************** ADD NEW MEMBER AUTO LOAN INDEX END ***********************/

		/***************** ADD AUTO LOAN PROPOSAL START ***********************/
		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				addAutoLoanResponse: action.payload,
				addAutoLoanArr: docodeHexResponse(action.payload, 'CreateAutoLoanProposalKey'),
			};

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_PROPOSAL_FAILURE:
			return { ...state, addAutoLoanResponse: action.payload };

		case AutoLoanProposalActionTypes.ADD_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addAutoLoanResponse: null };
		/***************** ADD AUTO LOAN PROPOSAL END ***********************/

		/***************** FETCH AUTO LOAN PROPOSAL START ***********************/
		case AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				fetchAutoLoanResponse: action.payload,
				fetchAutoLoanArr: docodeHexResponse(action.payload, 'fetchAutoLoanProposalKey'),
			};

		case AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_FAILURE:
			return { ...state, fetchAutoLoanResponse: action.payload };

		case AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, fetchAutoLoanResponse: null };
		/***************** FETCH AUTO LOAN PROPOSAL END ***********************/

		/***************** FETCH AUTO LOAN PROPOSAL DETAIL START ***********************/
		case AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				getParticularAutoLoanResponse: action.payload,
				getParticularAutoLoanArr: docodeHexResponse(
					action.payload,
					'GetParticularAutoLoanProposalKey',
				),
			};

		case AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_FAILURE:
			return {
				...state,
				getParticularAutoLoanResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, getParticularAutoLoanResponse: null };

		case AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESET_COMPONENT_START:
			return { ...state, getParticularAutoLoanResponse: null, getParticularAutoLoanArr: [] };
		/***************** FETCH AUTO LOAN PROPOSAL DETAIL END ***********************/

		/***************** APPROVE AUTO LOAN PROPOSAL DETAIL START ***********************/
		case AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				approveAutoLoanIndexResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_FAILURE:
			return { ...state, approveAutoLoanIndexResponse: action.payload };

		case AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, approveAutoLoanIndexResponse: null };
		/***************** APPROVE AUTO LOAN PROPOSAL DETAIL END ***********************/

		/***************** REVERT AUTO LOAN PROPOSAL DETAIL START ***********************/
		case AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				revertAutoLoanIndexResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_FAILURE:
			return { ...state, revertAutoLoanIndexResponse: action.payload };

		case AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, revertAutoLoanIndexResponse: null };
		/***************** REVERT AUTO LOAN PROPOSAL DETAIL END ***********************/

		/***************** DELETE AUTO LOAN PROPOSAL DETAIL START ***********************/
		case AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				deleteAutoLoanIndexResponse: action.payload,
			};

		case AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_FAILURE:
			return { ...state, deleteAutoLoanIndexResponse: action.payload };

		case AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, deleteAutoLoanIndexResponse: null };
		/***************** DELETE AUTO LOAN PROPOSAL DETAIL END ***********************/

		/***************** GET DEALER LIST START ***********************/
		case AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_FAILURE:
			return {
				...state,
				fetchAllDealerListResp: action.payload,
			};

		case AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST__RESPONSE_CHANGED:
			return { ...state, fetchAllDealerListResp: null };

		case AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_SUCCESS:
			return {
				...state,
				fetchAllDealerListResp: action.payload,
				fetchAllDealerListArr: docodeHexResponse(action.payload, 'GetDealerListKey'),
			};

		/*****************  GET DEALER LIST END ***********************/

		/***************** GET PERMANT PINCODE START ***********************/
		case AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_FAILURE:
			return { ...state, getPermantPincodeResp: action.payload };

		case AutoLoanProposalActionTypes.GET_PERMANT_PINCODE__RESPONSE_CHANGED:
			return { ...state, getPermantPincodeResp: null };

		case AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_SUCCESS:
			return {
				...state,
				getPermantPincodeResp: action.payload,
				getPermantPincodeArr: docodeHexResponse(action.payload, 'FetchPincodeListKey'),
			};

		/***************** GET PERMANT PINCODE END ***********************/

		/***************** CHECK AUTO LOAN MANDATORY DETAILS START ***********************/
		case AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_FAILURE:
			return { ...state, checkAutoLoanMandatoryDetailsResponse: action.payload };

		case AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS__RESPONSE_CHANGED:
			return { ...state, checkAutoLoanMandatoryDetailsResponse: null };

		case AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_SUCCESS:
			return {
				...state,
				checkAutoLoanMandatoryDetailsResponse: action.payload,
				checkAutoLoanMandatoryDetailsArr: docodeHexResponse(
					action.payload,
					'AutoLoanMandatoryFieldsKey',
				),
			};

		/***************** CHECK AUTO LOAN MANDATORY DETAILS START ***********************/
		case AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_FAILURE:
			return { ...state, UpdateAutoLoanIndexReponse: action.payload };

		case AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_REPONSE_CHANGED:
			return { ...state, UpdateAutoLoanIndexReponse: null };

		case AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_SUCCESS:
			return {
				...state,
				UpdateAutoLoanIndexReponse: action.payload,
			};

		default:
			return state;
	}
};
